import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BACKEND_API_URL } from '../../../utility/api';

export const ReceptionistAPI = createApi({
  reducerPath: 'ReceptionistAPI',
  tagTypes: ['Receptionist'],
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getReceptionists: builder.query({
      query: ({ page = 1, limit = 10, search = "" } = {}) => ({
        url: "users/receptionists",
        params: { page, limit, ...(search ? { search } : {}) },
      }),
      providesTags: ['Receptionist'],
    }),
    addReceptionist: builder.mutation({
      query: (data) => ({
        url: `users/receptionists`,
        method: "POST", 
        body:data
      }), 
      invalidatesTags: ['Receptionist'],
    }),

    getReceptionistsById: builder.query({
      query: (id) => ({
        url: `users/receptionists/${id}`, 
      }), 
    }),

    updateReceptionist: builder.mutation({
      query: ({data,id}) => ({
        url: `users/receptionists/${id}`,
        method: "PUT", 
        body:data
      }), 
      invalidatesTags: ['Receptionist'],
    }),

    deleteReceptionists: builder.mutation({
      query: (id) => ({
        url: `users/receptionists/${id}`,
        method: "DELETE", 
      }),
      invalidatesTags: ['Receptionist'],
    }),

  }),
});

export const { 
    useGetReceptionistsByIdQuery,
    useGetReceptionistsQuery,
    useAddReceptionistMutation,
    useDeleteReceptionistsMutation,
    useUpdateReceptionistMutation

 } = ReceptionistAPI;
